<tk-checkbox-control 
    [formControlName]="controlName"
    [invalid]="isInvalid"
	[checkboxId]="agreementCheckboxId"
  >
  <section class="message" [class.message--invalid]="isInvalid">
    Нажимая на кнопку “{{ buttonLabel }}”, вы даёте согласие на&nbsp;
    <a routerLink="/privacy-policy" target="_blank" class="link" [class.link--invalid]="isInvalid" [class.link--white]="theme === 'white'">
      обработку персональных данных
    </a>
	</section>
  </tk-checkbox-control>
